import { render, staticRenderFns } from "./ElectiveReEnrollment.vue?vue&type=template&id=84d67304"
import script from "./ElectiveReEnrollment.vue?vue&type=script&lang=js"
export * from "./ElectiveReEnrollment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports